import { render, staticRenderFns } from "./footer_b.vue?vue&type=template&id=4783bccf&scoped=true&"
import script from "./footer_b.vue?vue&type=script&lang=js&"
export * from "./footer_b.vue?vue&type=script&lang=js&"
import style0 from "./footer_b.vue?vue&type=style&index=0&id=4783bccf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4783bccf",
  null
  
)

export default component.exports